import { ContextMenu as BaseContextMenu } from '@base-ui/react/context-menu'
import { VariantProps } from 'class-variance-authority'
import { twMerge } from 'tailwind-merge'
import { menuItemVariants } from '../../menu/nested/item'
import type { PartProps } from '../../../lib/part-props'

interface ContextMenuItemProps extends PartProps<BaseContextMenu.Item.Props>, VariantProps<typeof menuItemVariants> {
  className?: string
}

function ContextMenuItem({ variant, className, children, ...props }: ContextMenuItemProps) {
  return (
    <BaseContextMenu.Item
      data-slot="list-item"
      className={twMerge(menuItemVariants({ variant }), className)}
      {...props}
    >
      {children}
    </BaseContextMenu.Item>
  )
}

export { ContextMenuItem }
